module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_11.afa49059.pdf";